import type { AppProps } from 'next/app'
import { VFC } from 'react'
import { GuestModals, Modals } from 'src/components/hoc/asPage/modals'
import { SEO, SEOProps } from 'src/components/SEO'
import {
  DEFAULT_DESCRPIPTION,
  DEFAULT_IMAGE,
  DEFAULT_PAGE_TITLE,
  SITE_AUTHOR,
  SITE_TITLE,
} from 'src/data/common'
import { HOSTNAME } from 'src/utils/env'
import { extractPathname } from 'src/utils/routes'

type AsPage = <P = {}, Q = {}>(
  Component: VFC<PageProps<P, Q>>,
  seoProps?: Partial<SEOProps>,
  guest?: boolean,
) => VFC<PageProps<P, Q> & { router: AppProps['router'] }>

export type PageProps<P = {}, Q = {}> = P & {
  router: {
    query: Partial<Q>
  }
}

export const asPage: AsPage = (Component, seoProps, guest) => (props) => {
  return (
    <>
      <SEO
        description={DEFAULT_DESCRPIPTION}
        image={DEFAULT_IMAGE}
        siteTitle={SITE_TITLE}
        pageTitle={DEFAULT_PAGE_TITLE}
        author={SITE_AUTHOR}
        siteUrl={`https://${HOSTNAME}`}
        path={extractPathname(props.router.asPath)}
        {...seoProps}
      />
      <Component {...props} />
      {guest ? <GuestModals /> : <Modals />}
    </>
  )
}
